var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExportReportIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.56396 4.25L6.95021 0.5L9.33646 4.25H7.31771L7.31771 11.3333H6.48438L6.48438 4.25H4.56396ZM9.49967 7.37488V6.54154H13.6663V16.1249H0.333008V6.54154H4.49967V7.37488H1.16634V15.2915H12.833V7.37488H9.49967Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExportReportIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ExportReport_icon.970d1aff986e1af1aba265ede61e5bfc.svg";